import * as actionTypes from '../../../modules/actions'

import auth from '../../../modules/auth'

const initialState = {
  proposal: null,
  accept: {
    step: 1,
    submitting: false,
    error: null,
  },
  showProfile: {
    step: 1,
    submitting: false,
    error: null,
  },
  doctor: null,
  payment: {
    acceptPrice: 0,
    showProfilePrice: 0,
    payjpToken: null,
    cardNumber: '',
    expDate: '',
  }
}

export default (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.RESET_PROPOSAL_STATE:
      return initialState
    case actionTypes.INIT_PROPOSAL:
      return initProposal(state, action)
    case actionTypes.UPDATE_ACCEPT_KEY:
      return updateAcceptKey(state, action)
    case actionTypes.UPDATE_PAYMENT_KEY:
      return updatePayment(state, action)
    case actionTypes.SET_ACCEPT_PRICE:
      return setAcceptPrice(state, action)
    case actionTypes.ACCEPT_PROPOSAL_RESPONSE:
      return acceptProposalResponse(state, action)
    case actionTypes.GET_CARD_INFO_FROM_TOKEN:
      return getCardInfoFromToken(state, action)
    case actionTypes.SET_SHOW_PROFILE_PRICE:
      return setShowProfilePrice(state, action)
    case actionTypes.PAY_SHOW_PROFILE_RESPONSE:
      return payShowProfileResponse(state, action)
    case actionTypes.SET_DOCTOR_INFO:
      return setDoctorInfo(state, action)
    case actionTypes.UPDATE_SHOW_PROFILE_KEY:
      return updateShowProfileKey(state, action)
    default:
      return state
  }
}

const updateShowProfileKey = (state, action) => {
  return {
    ...state,
    showProfile: {
      ...state.showProfile,
      [action.payload.key]: action.payload.value,
    }
  }
}

const setDoctorInfo = (state, action) => {
  return {
    ...state,
    doctor: action.payload.doctor,
  }
}

const payShowProfileResponse = (state, action) => {
  if (action.payload.success) {
    return {
      ...state,
      showProfile: {
        ...state.showProfile,
        step: 2,
        submitting: false,
      }
    }
  } else {
    return {
      ...state,
      showProfile: {
        ...state.showProfile,
        error: action.payload.error,
        submitting: false,
      }
    }
  }
}

const setShowProfilePrice = (state, action) => {
  return {
    ...state,
    payment: {
      ...state.payment,
      showProfilePrice: action.payload.showProfilePrice
    }
  }
}

const getCardInfoFromToken = (state, action) => {
  const { cardNumber, expDate } = action.payload
  let info = auth.getInfo()
  info.customer.card_info = {
    card_number: cardNumber,
    exp: expDate,
  }
  return {
    ...state,
    payment: {
      ...state.payment,
      cardNumber,
      expDate,
    }
  }
}

const acceptProposalResponse = (state, action) => {
  if (action.payload.success) {
    return {
      ...state,
      accept: {
        ...state.accept,
        step: 2,
        submitting: false,
      }
    }
  } else {
    return {
      ...state,
      accept: {
        ...state.accept,
        error: action.payload.error,
        submitting: false,
      }
    }
  }
}

const setAcceptPrice = (state, action) => {
  return {
    ...state,
    payment: {
      ...state.payment,
      acceptPrice: action.payload.acceptPrice
    }
  }
}

const updatePayment = (state, action) => {
  return {
    ...state,
    payment: {
      ...state.payment,
      ...action.payload.payment,
    }
  }
}

const updateAcceptKey = (state, action) => {
  return {
    ...state,
    accept: {
      ...state.accept,
      [action.payload.key]: action.payload.value,
    }
  }
}

const initProposal = (state, action) => {
  return {
    ...state,
    proposal: action.payload.proposal
  }
}



// WEBPACK FOOTER //
// ./src/routes/opinion/modules/reducer.js